<script>
    import * as EDIT_PROFILE_TYPE from "@/store/modules/edit-profile/type";
    import {createNamespacedHelpers} from "vuex";
    import $ from 'jquery';
    import moment from "moment";
    import IConstants from '@/common/constants/IConstants';

    const {mapActions, mapGetters, mapState: mapProfileState, mapMutations: mapProfileMutations} = createNamespacedHelpers("editProfile");
    const {mapGetters: mapForceNewsGetters} = createNamespacedHelpers("forceNews");
    const { mapMutations: mapNewsMutations} = createNamespacedHelpers("news");

export default {
    name: "EditProfileMixins",
    data() {
        return {
            formatData: this.$t("profile.format.date_time"),
            processAction: false,
            changeBlockInfo: null,
        }
    },
    computed: {
        ...mapGetters(['activeBlock']),
        ...mapForceNewsGetters(['mapGroupFieldAmsCustomer']),
        ...mapProfileState({
            profileState: state => state,
        }),
        loginNotifyTitleList() {
            const result = [];
            const hasAdditionalEmail = this.profileState.hasAdditionEmail;
            switch (this.profileState.loginNotifyFlgView) {
                case "0":
                    result.push('profile.label.screen.login_notify_flg.off');
                    break;
                case "1":
                    result.push('profile.label.screen.login_notify_flg.main_mail');
                    break;
                case "2":
                    if (hasAdditionalEmail) {
                        result.push('profile.label.screen.login_notify_flg.additional_mail');
                    } else {
                        result.push('profile.label.screen.login_notify_flg.off');
                    }
                    break;
                case "3":
                    if (hasAdditionalEmail) {
                        result.push('profile.label.screen.login_notify_flg.on');
                    } else {
                        result.push('profile.label.screen.login_notify_flg.main_mail');
                    }
                    break;
            }
            return result;
        },
        getPasskeyStatusLabel() {
            return String(IConstants.PASSKEY_STATUS.UNSET_YET) === String(this.profileState.passkeyStatus)
                ? this.$t('profile.label.fido.passkey.status.unset.yet')
                : this.$t('profile.label.fido.passkey.status.already.set')
        },
        customerInfoView() {
            return this.profileState.customerInfoView
        },
        input() {
            return this.profileState.input;
        },
        getFinancialAssetsLabel() {
          const selectFinancialAsset = this.$options.filters.getByProperty('key', this.input["amsCustomerDetail.financialAssets"], this.IConstants.listFinalAssets)
          return selectFinancialAsset ? this.$t(selectFinancialAsset.value) : "";
        },
        getInvestmentAmountLabel() {
            const selectInvestmentAmount = this.$options.filters.getByProperty('key', this.input["amsCustomerDetail.investmentAmount"], this.IConstants.listFinalAssets)
            return selectInvestmentAmount ? this.$t(selectInvestmentAmount.value) : "";
        },
        getInvestmentViewText() {
            const investmentView = this.input["amsCustomerDetail.investmentView"];
            let result = '';

            if (investmentView.purposeShortTermFlg === this.IConstants.FLAG.ACTIVE) {
                result = this.$t("profile.investment.purpose_short_term_flg");
            }

            if (investmentView.purposeLongTermFlg === this.IConstants.FLAG.ACTIVE) {
                result && (result = result + "<br/> ");
                result = result + this.$t("profile.investment.purpose_long_term_flg");
            }

            if (investmentView.purposeExchangeFlg === this.IConstants.FLAG.ACTIVE) {
                result && (result = result + "<br/> ");
                result = result + this.$t("profile.investment.purpose_exchange_flg");
            }

            if (investmentView.purposeSwapFlg === this.IConstants.FLAG.ACTIVE) {
                result && (result = result + "<br/> ");
                result = result + this.$t("profile.investment.purpose_swap_flg");
            }

            if (investmentView.purposeHedgeAssetFlg === this.IConstants.FLAG.ACTIVE) {
                result && (result = result + "<br/> ");
                result = result + this.$t("profile.investment.purpose_hedge_asset_flg");
            }

            if (investmentView.purposeHighIntFlg === this.IConstants.FLAG.ACTIVE) {
                result && (result = result + "<br/> ");
                result = result + this.$t("profile.investment.purpose_high_int_flg");
            }

            if (investmentView.purposeEconomicFlg === this.IConstants.FLAG.ACTIVE) {
                result && (result = result + "<br/> ");
                result = result + this.$t("profile.investment.purpose_economic_flg");
            }
            return result;
        },
        getBoInvestmentPurposeViewText() {
            const boInvestmentView = this.input["amsCustomerDetail.boInvestmentPurposeView"];
            let result = '';
            if (boInvestmentView.boPurposeShortTermFlg === this.IConstants.FLAG.ACTIVE) {
                result = this.$t("profile.bo_investment_purpose.bo_purpose_short_term_flg");
            }

            if (boInvestmentView.boPurposeDispAssetMngFlg === this.IConstants.FLAG.ACTIVE) {
                result && (result = result + "<br/> ");
                result = result + this.$t("profile.bo_investment_purpose.bo_purpose_disp_asset_mng_flg");
            }

            if (boInvestmentView.boPurposeHedgeFlg === this.IConstants.FLAG.ACTIVE) {
                result && (result = result + "<br/> ");
                result = result + this.$t("profile.bo_investment_purpose.bo_purpose_hedge_flg");
            }
            return result;
        },
        getCryptInvestmentViewText() {
            const cryptInvestmentView = this.input["amsCustomerDetail.cryptInvestmentPurposeView"];
            let result = '';

            if (cryptInvestmentView.cryptoPurposeFluctuationFlg === this.IConstants.FLAG.ACTIVE) {
                result = result + this.$t("trs.front.crypto.registration.label.fluctuations.crypto.value");
            }

            if (cryptInvestmentView.cryptoPurposeDiverseFlg === this.IConstants.FLAG.ACTIVE) {
                result && (result = result + "<br/> ");
                result = result + this.$t("trs.front.crypto.registration.label.diversified.investment");
            }

            if (cryptInvestmentView.cryptoPurposeAssetFlg == this.IConstants.FLAG.ACTIVE) {
                result && (result = result + "<br/> ");
                result = result + this.$t("trs.front.crypto.registration.label.asset.formation");
            }
            return result;
        },
        alertAuthenticateTitleList() {
            const result = [];
            const hasAdditionalEmail = this.profileState.hasAdditionEmail;
            switch (String(this.profileState.customerInfoView['alertAuthFlg'])) {
                case "0":
                    result.push('profile.label.screen.login_notify_flg.off');
                    break;
                case "1":
                    result.push('profile.label.screen.login_notify_flg.main_mail');
                    break;
                case "2":
                    if (hasAdditionalEmail) {
                        result.push('profile.label.screen.login_notify_flg.additional_mail');
                    } else {
                        result.push('profile.label.screen.login_notify_flg.off');
                    }
                    break;
                case "3":
                    if (hasAdditionalEmail) {
                        result.push('profile.label.screen.login_notify_flg.on');
                    } else {
                        result.push('profile.label.screen.login_notify_flg.main_mail');
                    }
                    break;
            }
            return result;
        },
    },
    methods: {
        ...mapProfileMutations(['assignProfileState']),
        ...mapActions([
            EDIT_PROFILE_TYPE.INIT_PROFILE_INFO,
            EDIT_PROFILE_TYPE.SET_ADDITIONAL_MAIL,
        ]),
        ...mapNewsMutations([
            'updateFields'
        ]),
        async saveAmsCustomerDetail() {
          const blockRef = this.$refs[this.changeBlockInfo];
            if (this.input['amsCustomerDetail.corporationType'] === IConstants.CUSTOMER_TYPE.CORPORATION) {
                if (this.changeBlockInfo === 'CUSTOMER_BENEFIC_NAME') {
                    if (blockRef.input['amsCustomerDetail.beneficOwnerEstablishDate']) {
                        blockRef.input['amsCustomerDetail.beneficOwnerEstablishDate'] = moment(blockRef.input['amsCustomerDetail.beneficOwnerEstablishDate'], 'YYYY/MM/DD').format('YYYYMMDD');
                    }
                    if (blockRef.input['amsCustomerDetail.beneficOwnerEstablishDate2']) {
                        blockRef.input['amsCustomerDetail.beneficOwnerEstablishDate2'] = moment(blockRef.input['amsCustomerDetail.beneficOwnerEstablishDate2'], 'YYYY/MM/DD').format('YYYYMMDD');
                    }
                    if (blockRef.input['amsCustomerDetail.beneficOwnerEstablishDate3']) {
                        blockRef.input['amsCustomerDetail.beneficOwnerEstablishDate3'] = moment(blockRef.input['amsCustomerDetail.beneficOwnerEstablishDate3'], 'YYYY/MM/DD').format('YYYYMMDD');
                    }
                    if (blockRef.input['amsCustomerDetail.beneficOwnerEstablishDate4']) {
                       blockRef.input['amsCustomerDetail.beneficOwnerEstablishDate4'] = moment(blockRef.input['amsCustomerDetail.beneficOwnerEstablishDate4'], 'YYYY/MM/DD').format('YYYYMMDD');
                    }
                }
            }
            if ((this.validateInvestment(this.input) && this.changeBlockInfo === "CUSTOMER_FX_INVEST") || this.processAction) {
                console.error("Can not pass validate all field");
                return;
            }
            $("html, body").animate({scrollTop: 0}, "slow");
            const {$v} = blockRef;

            $v.$touch();
            if ($v.$anyError) {
                console.error("Can not pass validate all field");
                return;
            }
            let formData = null;
            if (blockRef.input !== null) {
                formData = this.preparedDataInput(blockRef);
                formData.append("screenName", IConstants.SCREEN_NAME.CUSTOMER_INFO);
            }
            try {
                const data = await this.$service.getService('profile').saveAmsCustomerDetail(formData);
                this.$modal.reAssignProfileStateAndReEmitMaskingVerifiedEvent({
                    authInfo: data.authenticateModel,
                    screenName: IConstants.SCREEN_NAME.CUSTOMER_INFO
                });
                
                // hot fix for axios Network Error, because it isn't caught by catch block
                if (data && this.ServiceUtils.isAxiosNetworkError(data.message)) {
                    throw "Axios Network Error";
                }
                this.$emit('onComplete', data);
                this.$emit('onMessage', data.errorMessage, this.IConstants.API_MESSAGE_TYPE.ERROR);
                if (data.result === this.IConstants.RESULT_AJAX.SUCCESS) {
                    if (data.successMessage === 'profile.update.success.corp.change_name_address') {
                        this.$emit('onMessage',
                            this.$t('profile.update.success.corp.change_name_address', {param1: this.profileState.SUPPORT_DOCUMENT_URL}),
                            this.IConstants.API_MESSAGE_TYPE.SUCCESS);
                    } else if (data.successMessage === 'profile.update.success.indv.change_name_address') {
                        this.$emit('onMessage',
                            this.$t('profile.update.success.indv.change_name_address', {
                                param1: this.profileState.NEW_UPLOAD_DOCUMENT_URL + "/home?source=min-st",
                                param2: this.input['amsCustomerDetail.corporationType'] == IConstants.CUSTOMER_TYPE.CORPORATION ? this.profileState.NEW_UPLOAD_DOCUMENT_URL : this.profileState.SUPPORT_DOCUMENT_URL
                            }),
                            this.IConstants.API_MESSAGE_TYPE.SUCCESS);
                    } else if (data.successMessage === 'profile.update.success.indv.change_name_address.uploadFile') {
                        this.$emit('onMessage',
                            this.$t('profile.update.success.indv.change_name_address.uploadFile', {param1: this.profileState.SUPPORT_DOCUMENT_URL}),
                            this.IConstants.API_MESSAGE_TYPE.SUCCESS);
                    } else {
                        // this code block for case Customer deletes additional mail
                        if (data.amsCustomerInfoView && data.amsCustomerInfoView.additionalEmail === '') {
                            this[EDIT_PROFILE_TYPE.SET_ADDITIONAL_MAIL]({hasAdditionEmail: false});
                        }

                        this.$emit('onMessage',
                            data.successMessage,
                            this.IConstants.API_MESSAGE_TYPE.SUCCESS);
                    }
                }
            } catch (error) {
                this.$emit('onMessage', "error.happen", this.IConstants.API_MESSAGE_TYPE.ERROR);
            } finally {
                blockRef.reverseInput();
                this.processAction = false;
            }
        },
        showErrorMsg(value) {
            this.$emit('onMessage', this.$t(value), this.IConstants.API_MESSAGE_TYPE.ERROR);
        },
    }
}
</script>
